import { classes, DropDownMenu, FieldViewModel, FormGroup, isUndefinedOrNull, labels, react } from "../../../omnia"
import { PlanContext } from "../../context"
import { PlanState } from "../../types"
import { resetPlan } from "../year/Reset"
import { setupYear } from "../year/SetupYear"
import { FieldSelector } from "./FieldSelector"


interface Props {
    state: PlanState
    disableUi: boolean
}

export function Fields({ state, disableUi }: Props) {

    const { api, dispatch } = React.useContext(PlanContext)
    const { year, fields } = api

    const selectedFieldId = state?.selectedField?.fieldId

    const hasOtherYears = state.plans.some(p => p !== year)

    const selectField = (id: number) => dispatch({ type: "selectField", selectedFieldId: id })

    const reset = () => resetPlan(api, dispatch)

    const setup = () => {
        if (hasOtherYears) {
            setupYear(state, api, dispatch)
        }
    }

    return <div className="field-selector">

        <FormGroup className="field">

            <FieldSelector
                selectedFieldId={selectedFieldId}
                disableUi={disableUi}
            />

            <DropDownMenu
                button={
                    <button type="button" className="btn btn-icon btn-md transparent">
                        <i className="fas fa-ellipsis-v"></i>
                    </button>
                }>

                <>

                    <li role="menuitem" className={classes((!hasOtherYears) && "disabled")}>
                        <a onClick={setup}>Setup year {year} from another year</a>
                    </li>

                    <li role="menuitem">
                        <a onClick={reset}>Reset year {year}</a>
                    </li>

                </>

            </DropDownMenu>


        </FormGroup>

        <FieldDetails fields={fields} fieldId={selectedFieldId} />

    </div>

}


function FieldDetails({ fields, fieldId }: { fields: FieldViewModel[], fieldId: number }) {

    const field = React.useMemo(() => fields.find(f => f.fieldId === fieldId)?.field, [fields, fieldId])

    if (!field) {
        return null
    }

    return <div className="field-details">

        <Param label="Field drainage" value={field.FieldDrainage} provider={labels.FieldDrainage} />
        <YesNo label="Water course" value={field.WaterCourse} />

        <Param label="Soil erosion risk" value={field.SoilErosionRisk} provider={labels.SoilErosionRisk} />
        <YesNo label="Sensitive habitat" value={field.SensitiveHabitat} />

        <Param label="Wind erosion risk" value={field.WindErosionRisk} provider={labels.WindErosionRisk} />
        <YesNo label="Ancient monument" value={field.AncientMonument} />

    </div>
}

function Param({ value, label, provider }: { value: number, label: string, provider: (value: number) => string }) {

    return <div className="a">
        <label>{label}</label>
        {
            value
                ? <span>{provider(value)}</span>
                : <span className="n">(Not set)</span>
        }
    </div>
}

function YesNo({ value, label }: { value: boolean, label: string }) {

    return <div className="a">
        <label>{label}</label>
        {
            isUndefinedOrNull(value)
                ? <span className="n">(Not set)</span>
                : <span>{value ? "Yes" : "No"}</span>
        }
    </div>
}
